import { render } from "./EditCompetition.vue?vue&type=template&id=465d3649&scoped=true"
import script from "./EditCompetition.vue?vue&type=script&lang=js"
export * from "./EditCompetition.vue?vue&type=script&lang=js"

import "./EditCompetition.vue?vue&type=style&index=0&id=465d3649&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465d3649"]])

export default __exports__